module.exports = __webpack_public_path__ + "img/upload-file-icon.7bad50f9.png";